import React, { useEffect, useRef, useState } from 'react';
import { func, array, bool, string } from 'prop-types';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { H3 } from '../index';

import css from './SellerChat.module.css';

const SellerChat = props => {
  const { messages, sendMessageInProgress, onSendMessage, titleMsgId, descriptionMsgId } = props;
  const intl = useIntl();
  const [text, setText] = useState('');
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages.length]);

  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed || sendMessageInProgress) return;
    onSendMessage(trimmed).then(() => setText(''));
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const formatTime = timestamp => {
    return intl.formatDate(new Date(timestamp), {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={css.chat}>
      <H3 className={css.chatTitle}>
        <FormattedMessage id={titleMsgId} />
      </H3>
      <p className={css.chatDescription}>
        <FormattedMessage id={descriptionMsgId} />
      </p>

      <div className={css.messageList}>
        {messages.length === 0 ? (
          <p className={css.emptyChat}>
            <FormattedMessage id="SellerChat.empty" />
          </p>
        ) : (
          messages.map((msg, index) => {
            const isSeller = msg.author === 'seller';
            return (
              <div key={index} className={isSeller ? css.messageSeller : css.messageAdmin}>
                <div className={isSeller ? css.bubbleSeller : css.bubbleAdmin}>
                  <p className={css.bubbleText}>{msg.message}</p>
                  <span className={css.bubbleTime}>{formatTime(msg.timestamp)}</span>
                </div>
              </div>
            );
          })
        )}
        <div ref={bottomRef} />
      </div>

      <div className={css.inputRow}>
        <textarea
          className={css.textarea}
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          rows={3}
          placeholder={intl.formatMessage({ id: 'SellerChat.placeholder' })}
          disabled={sendMessageInProgress}
        />
        <button
          className={css.sendButton}
          onClick={handleSend}
          disabled={!text.trim() || sendMessageInProgress}
        >
          <FormattedMessage id="SellerChat.send" />
        </button>
      </div>
    </div>
  );
};

SellerChat.defaultProps = {
  messages: [],
  sendMessageInProgress: false,
  titleMsgId: 'SellerChat.title',
  descriptionMsgId: 'SellerChat.description',
};

SellerChat.propTypes = {
  messages: array,
  sendMessageInProgress: bool,
  onSendMessage: func.isRequired,
  titleMsgId: string,
  descriptionMsgId: string,
};

export default SellerChat;
